import axios from "axios";

const pickupPointsService = {
  async fetch() {
    return axios.get('/order/api/points');
  }
};

export default pickupPointsService;